import Vue from 'vue'
import Router from 'vue-router'
import { loc } from '@/axios/storage'
const Home = () => import('@/pages/Home');
const ProDetail = () => import('@/pages/ProDetail');
const Login = () => import('@/pages/Login')
const Users = () => import('@/pages/Users')
const Errors = () => import('@/pages/Errors')

//home分页
const Home_001 = () => import('@/components/home/tabs/Home_001')
const Aboutme = () => import('@/components/home/Aboutme')

// 选品
const Search = () => import('@/pages/SearchModel')
// 新闻资讯
const News = () => import('@/pages/News')
//cartlist分页
const CartsProList = () => import("@/components/cartlist/CartsProList")
// 结算页面
const Settlement = () => import("@/components/cartlist/Settlement")
//users分页
const Person = () => import("@/components/users/Person")
// 订单
const Indent = () => import("@/components/users/Indent")
// 空白页跳转
const Redirect = () => import("@/components/Redirect")
// 产品关联页
const Sku = () => import("@/components/users/Sku")
const Stream = () => import("@/components/users/Stream")
const WorkOrder = () => import("@/components/users/WorkOrder")
const Develop = () => import("@/components/users/Modeling")
const Message = () => import("@/components/users/Message")
const WhiteSku = () => import("@/components/users/WhiteSku")
const Address = () => import("@/components/users/Address")
const StoreAuthorization = () => import("@/components/users/StoreAuthorization")
Vue.use(Router)

export default new Router({
  routes: [
    //默认跳转首页
    { path: '/', redirect: { name: 'home' } },
    //首页
    {
      path: '/home', name: 'home',
      component: Home,
      redirect: { name: 'index' },
      children: [
        { path: 'index', component: Home_001, name: 'index' },  //首页
        { path: 'product', component: Search, name: 'product' },  //选品
        { path: 'prodetail', name: 'prodetail', component: ProDetail }, // 产品详情
        { path: 'aboutme', name: 'aboutme', component: Aboutme }, // 关于我们
        { path: 'news', name: 'news', component: News }, // 新闻
        { path: 'redirect', name: 'redirect', component: Redirect },
      ]
    },


    //登录
    { path: '/login', name: 'login', component: Login },
    //注册
    { path: '/register', name: 'register', component: Login },

    //个人中心
    {
      path: '/users', name: 'users', component: Users, redirect: { name: 'person' },
      //导航钩子  检测 是否在登录状态下才能进入 个人中心 相关页面
      beforeEnter: (to, from, next) => {
        let url = to.path.split("/")[1]
        if (url == "users") {
          if (!!loc.get('client_token')) {
            next()
          } else {
            next({ name: 'login' })
          }
        } else {
          next()
        }
      },
      children: [
        { path: 'person', component: Person, name: 'person' }, //个人中心
        { path: 'stream', component: Stream, name: 'stream' }, //流水
        { path: 'indent', component: Indent, name: 'indent' }, //我的订单
        { path: 'sku', component: Sku, name: 'sku' }, //我的订单
        { path: 'whitesku', component: WhiteSku, name: 'whitesku' }, //sku白名单
        { path: 'cartsproList', component: CartsProList, name: 'cartsproList' }, // 购物车
        { path: 'settlement', component: Settlement, name: 'settlement' }, // 结算
        { path: 'workorder', component: WorkOrder, name: 'workorder' }, // 工单管理
        { path: 'develop', component: Develop, name: 'develop' }, // 2D/3D建模
        { path: 'message', component: Message, name: 'message' }, // 站内信
        { path: 'address', component: Address, name: 'address' }, // 2D/3D建模
        { path: 'storeAuthorization', component: StoreAuthorization, name: 'storeAuthorization' }, // 店铺授权

      ]
    },

    //error 访问出错了
    { path: '/error', component: Errors, name: 'error' }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js